import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Report } from '../../models/report.model';

@Component({
  selector: 'app-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.scss'],
})
export class NotesComponent implements OnChanges {
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['notes']) {
      this.notesInternal = structuredClone(this.notes);
    }
  }

  @Input() notes!: Report.Notes;
  @Input() isLoading = false;

  notesInternal!: Report.Notes;

  @Output() notesChanged = new EventEmitter<Report.Notes>();
  @Output() notesEnabled = new EventEmitter<boolean>();
  @Output() cancled = new EventEmitter<void>();

  onNotesChanged(notes: Report.Notes): void {
    this.notesInternal = notes;
  }

  onSaveSection(): void {
    this.notesChanged.emit(this.notesInternal);
  }

  onEnabled(isEnabled: boolean): void {
    this.notesEnabled.emit(isEnabled);
  }

  onCancled(): void {
    this.cancled.emit();
  }
}
